/**
 * @file banner
 * @author wangzian@baidu.com
 * */

import {Component} from 'san';
import './index.scss';

export default class InvokeAppBubble extends Component {
    static template = `
    <div class="invoke-app-banner" s-if="bannerItem.src">
        <img src="{{bannerItem.src}}" on-click="bannerClick"/>
        <div class="label" s-if="appOnly">APP专属</div>
    </div>
    `;

    initData() {
        return {
            bannerItem: {},
            appOnly: true
        };
    }

    bannerClick() {
        let bannerItem = this.data.get('bannerItem');
        this.fire('banner-click', bannerItem);
    }
}
